export const MOBILE_PAGE_HISTORY_MODE_LIST = [
  "createbooking",
  "editbooking",
  "detailbooking",
  "editvoucher",
  "menu-v2-detail",
  "menu-v2-mobile-detail",
  "pricing-rules-create",
  "pricing-rules-edit",
  "price-change-history",
  "edit-package",
  "accountManagement-profile-edit",
];
